import { useState } from 'react';

export function TodoForm({
    onAdd,
}) {
    const [title, setTitle] = useState('');
    const [deadline, setDeadline] = useState(new Date().toJSON().split('T')[0]);
    const handleSubmit = (e) => {
        e.preventDefault();

        onAdd(title, deadline);
        setTitle('');
        setDeadline(new Date().toJSON().split('T')[0]);
    };

    return (
        <div className="divide-gray-200 divide-y m-8">
            <form className="bg-white h-[56px] p-4 rounded shadow-md flex" onSubmit={handleSubmit}>
                <input type="text" name="todo" placeholder="Create new TODO ..." className="h-full flex-auto" value={title} onChange={(e) => setTitle(e.currentTarget.value)} />
                <input type="date" name="deadline" className="h-full w-64" value={deadline} onChange={(e) => setDeadline(e.currentTarget.value)} />
            </form>
        </div >
    );
};
